"use client";

import { memo } from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";
import { resolveEnum } from "./utils";

export const BeeOSDivider = memo(function BeeOSDivider({
  node,
  surfaceId,
}: A2UIComponentProps<Types.DividerNode>) {
  useA2UIComponent(node, surfaceId);
  const axis = resolveEnum<"horizontal" | "vertical">(node.properties.axis, "horizontal");

  const hostStyle: React.CSSProperties =
    node.weight !== undefined
      ? ({ "--weight": node.weight } as React.CSSProperties)
      : {};

  return (
    <div className="a2ui-divider" style={hostStyle}>
      <SeparatorPrimitive.Root
        orientation={axis}
        decorative
        className={
          axis === "vertical"
            ? "w-px self-stretch bg-border"
            : "h-px w-full bg-border my-1"
        }
      />
    </div>
  );
});
